<template>
  <div>
    <v-carousel height="280px" class="rounded-xl elevation-3 mb-4" hide-delimiter-background interval="5000" cycle
      show-arrows-on-hover delimiter-icon="mdi-circle-small">
      <v-carousel-item v-for="(item, key) in data" :key="key">
        <v-img :src="item.avatar && item.avatar.includes('.pdf') ? `/static/document_background.jpg` : item.avatar"
          height="100%" gradient="to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.3) 60%, rgba(0,0,0,0.1) 100%">
          <!-- Foreground content -->
          <div class="d-flex flex-column justify-end pa-6 pa-md-8" style="height: 100%; width: 100%;">
            <v-row align="end" justify="space-between" class="ma-0">
              <v-col cols="12" sm="8" md="9" class="pa-0 pr-sm-4 pb-3 pb-sm-0">
                <div class="text-h5 font-weight-bold white--text mb-2 text-truncate"
                  style="text-shadow: 1px 1px 3px rgba(0,0,0,0.6);">{{ item.title }}</div>
                <div class="white--text brief-carousel"
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; opacity: 0.9; font-size: 15px; line-height: 1.5; text-shadow: 1px 1px 2px rgba(0,0,0,0.6);"
                  v-html="item.brief"></div>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="pa-0 text-sm-right">
                <v-btn color="teal accent-4" dark class="rounded-pill font-weight-bold px-6 elevation-4"
                  style="text-transform: none; letter-spacing: 0.5px;" @click="viewModal = true, selected = item">
                  Đọc ngay <v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-img>
      </v-carousel-item>
    </v-carousel>

    <v-dialog v-model="viewModal" width="1200" class="rounded-xl overflow-hidden">
      <v-card v-if="selected" class="rounded-xl border-0">
        <v-card-title class="text-h6 font-weight-bold pt-5 px-6" style="word-break: normal; line-height: 1.3;">
          {{ selected?.title }}
        </v-card-title>
        <div class="px-6 mb-4">
          <v-divider></v-divider>
        </div>
        <div class="px-6 pb-2">
          <v-img v-if="selected.avatar && !selected.avatar.includes('.pdf')" :src="selected.avatar"
            class="rounded-lg elevation-2 mb-4" max-height="450" contain></v-img>
          <iframe v-else-if="selected.avatar && selected.avatar.includes('.pdf')" :src="selected.avatar"
            style="width:100%; height:650px; border:none;" class="rounded-lg elevation-2 mb-4"></iframe>
          <v-card-text class="pa-0 text-body-1 grey--text text--darken-3" v-show="!!selected?.brief"
            style="line-height: 1.6;">
            <span v-html="selected?.brief"></span>
          </v-card-text>
        </div>
        <v-card-actions class="pa-4 bg-grey-lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" text class="font-weight-bold rounded-lg px-4" style="text-transform: none;"
            @click="viewModal = false">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- pop up newsletter -->
    <v-dialog v-model="popNewsDialog" width="900" content-class="rounded-xl">
      <v-card dark class="rounded-xl overflow-hidden border-0">
        <v-carousel class="rounded-xl" height="auto" delimiter-icon="mdi-circle-small" hide-delimiter-background
          hide-delimiters show-arrows-on-hover cycle interval="5000">
          <v-carousel-item v-for="(item, key) in data" :key="key">
            <v-card class="transparent" flat>
              <v-img min-height="400px" style="max-height: calc(100vh - 200px);" width="100%" class="align-end"
                :src="item.avatar" cover position="center center"
                gradient="to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.2) 100%">
                <template v-slot:placeholder><img style="width:100%" src="/static/document_background.jpg"
                    alt=""></template>
                <div class="pa-8 pa-md-10">
                  <div class="text-h4 font-weight-black white--text mb-4"
                    style="text-shadow: 2px 2px 4px rgba(0,0,0,0.8); line-height: 1.2;">
                    {{ item.title }}
                  </div>
                  <div class="white--text text-body-1"
                    style="opacity: 0.9; text-shadow: 1px 1px 3px rgba(0,0,0,0.8); max-height: 150px; overflow-y: auto;">
                    <span v-html="item.brief"></span>
                  </div>
                </div>
              </v-img>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "slider",
  props: ["data"],
  data() {
    return {
      // sliders: [],
      // news: []
      viewModal: false,
      selected: null,
      popNewsDialog: true,
    }
  },
}
</script>

<style scoped>
::v-deep .brief-carousel a {
  color: white !important;
}

::v-deep .v-carousel__controls {
  pointer-events: none;
}

::v-deep .v-carousel__controls .v-btn {
  pointer-events: auto;
}
</style>